<script>
import Layout from '@/router/layouts/main';
import Grid from './components/grid.vue';
import Multiselect from 'vue-multiselect';
import statusMixin from '@/mixins/statusMixin';
import StatusMultiselect from '@/components/widgets/multiselects/status';
import FiltersCard from '@/components/widgets/cards/filters-search';
import FieldsMenu from '@/components/widgets/grids/grid-fields-menu.vue';
import Repositories from '@/repositories';
const WorkOrdersRepository = Repositories.get('workorders');
const ItemsRepository = Repositories.get('items');

export default {
  page: {
    title: 'Orders',
  },
  mixins: [statusMixin],
  components: {
    Layout,
    Grid,
    Multiselect,
    StatusMultiselect,
    FiltersCard,
    FieldsMenu,
  },
  data() {
    return {
      filters: null,
      searchText: '',
      showFilters: false,
      workOrdersList: [],
      itemsList: [],
      selectedWorkOrder: null,
      selectedItem: null,
    };
  },
  created() {
    WorkOrdersRepository.getAll()
      .then((response) => {
        if (response.data != null && response.data.data != null) {
          this.workOrdersList = response.data.data;
        }
      })
      .catch(() => {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      });

    ItemsRepository.getAll()
      .then((response) => {
        if (response.data != null && response.data.data != null) {
          this.itemsList = response.data.data;
        }
      })
      .catch(() => {
        this.$toast.errorToast(this.$t('errors.errorLoading'));
      });

    this.search();
  },
  methods: {
    search() {
      this.filters = {
        statusCodes: this.selectedStatusIds,
        suppliersIdPublic: this.selectedSuppliersIds,
        workOrderIdPublic:
          this.selectedWorkOrder != null
            ? this.selectedWorkOrder.idPublic
            : null,
        itemIdPublic:
          this.selectedItem != null ? this.selectedItem.idPublic : null,
        showClosed: this.showClosed,
        search: this.searchText,
      };
    },
    cancelSearch() {
      this.selectedStatus = [];
      this.selectedSuppliers = [];
      this.selectedWorkOrder = null;
      this.searchText = '';
      this.showClosed = false;

      this.search();
    },
    create() {
      this.$router.push({ name: 'createOrder' });
    },
    statusSelectionChanged(statusList) {
      this.selectedStatus = statusList;

      if (
        this.selectedStatus.filter((x) => x.statusCode == 'CLOSED').length > 0
      ) {
        this.showClosed = true;
      }
    },
    showClosedChanged(checked) {
      if (!checked) {
        this.selectedStatus = [
          ...this.selectedStatus.filter((x) => x.statusCode != 'CLOSED'),
        ];
      } else if (
        this.selectedStatus.length > 0 &&
        this.selectedStatus.findIndex((x) => x.statusCode == 'CLOSED') < 0
      ) {
        this.selectedStatus = [
          ...this.selectedStatus,
          {
            statusCode: 'CLOSED',
            statusName: 'orders.closed',
            statusVariant: 'secondary',
            statusOrder: 4,
          },
        ];
      }
    },
  },
  computed: {
    fieldsComputed() {
      return [
        {
          key: 'number',
          label: this.$t('general.number'),
          sortable: true,
        },
        {
          key: 'externalNumber',
          label: this.$t('orders.externalNumber'),
          sortable: true,
        },
        {
          key: 'supplierName',
          label: this.$t('suppliers.supplier'),
          sortable: true,
        },
        {
          key: 'shippingLocationName',
          label: this.$t('general.shippingLocation'),
          sortable: true,
          class: 'centered-field',
        },
        {
          key: 'statusOrder',
          label: this.$t('general.status'),
          sortable: true,
          class: 'centered-field',
        },
        {
          key: 'totalItems',
          label: this.$t('items.items'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'creationDate',
          label: this.$t('general.creationDate'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'receptionDate',
          label: this.$t('orders.receptionDate'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'manage',
          label: this.$t('general.see'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'order',
          label: this.$t('orders.orderVerb'),
          class: 'centered-field',
          sortable: true,
        },
        {
          key: 'delete',
          label: this.$t('general.delete'),
          class: 'centered-field',
          sortable: true,
        },
      ];
    },
    suppliers() {
      return this.$store.state.cache.suppliers;
    },
    ordersFiltersConfig: {
      get() {
        return this.$store.getters['localstorage/getByCode'](
          'ordersFiltersConfig'
        );
      },
      set(value) {
        this.$store.dispatch('localstorage/setByCode', {
          code: 'ordersFiltersConfig',
          config: value,
        });
      },
    },
    selectedStatus: {
      get() {
        return this.ordersFiltersConfig.selectedStatus;
      },
      set(value) {
        this.ordersFiltersConfig = {
          ...this.ordersFiltersConfig,
          selectedStatus: value,
        };
      },
    },
    showClosed: {
      get() {
        return this.ordersFiltersConfig.showClosed;
      },
      set(value) {
        this.ordersFiltersConfig = {
          ...this.ordersFiltersConfig,
          showClosed: value,
        };
      },
    },
    selectedSuppliers: {
      get() {
        return this.ordersFiltersConfig.selectedSuppliers;
      },
      set(value) {
        this.ordersFiltersConfig = {
          ...this.ordersFiltersConfig,
          selectedSuppliers: value,
        };
      },
    },
    selectedSuppliersIds() {
      return this.selectedSuppliers != null
        ? this.selectedSuppliers.map((a) => a.idPublic)
        : [];
    },
    selectedStatusIds() {
      return this.selectedStatus != null
        ? this.selectedStatus.map((a) => a.statusCode)
        : [];
    },
  },
};
</script>

<template>
  <Layout
    :title="$t('orders.orders')"
    :no-card="true"
    @esc-double-pressed="cancelSearch"
  >
    <div class="flex-box">
      <b-input-group class="search-bar custom-inventory-shadow">
        <b-form-input
          id="searchInput"
          type="text"
          style="border: none"
          :placeholder="$t('general.search')"
          @keydown.escape.prevent="cancelSearch()"
          @keydown.enter.prevent="search()"
          v-model="searchText"
        ></b-form-input>
        <b-input-group-append>
          <b-button
            style="border: none"
            variant="outline-light"
            @click="search()"
          >
            <i class="bx bx-search"></i>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <b-button
        class="flex-push mr-2 custom-inventory-shadow"
        @click="create()"
        variant="primary"
      >
        {{ $t('general.add') }}
      </b-button>

      <FieldsMenu id="orders-grid" :dropup="true" :fields="fieldsComputed" />
    </div>

    <FiltersCard @search="search" @cancel="cancelSearch">
      <template #row>
        <b-row>
          <b-col sm="12" lg="4">
            <b-form-group
              id="group-suppliers"
              :label="$t('suppliers.suppliers')"
              label-class="no-bold"
              label-for="supplierSelect"
            >
              <multiselect
                id="supplierSelect"
                ref="multiselectSupplier"
                v-model="selectedSuppliers"
                :options="suppliers"
                :label="'name'"
                track-by="idPublic"
                :placeholder="$t('general.pickAValue')"
                @remove="multiselectClosed($refs.multiselectSupplier)"
                :multiple="true"
                :show-labels="false"
                :hide-selected="true"
                :close-on-select="false"
                :clear-on-select="false"
                :searchable="false"
              >
                <template v-slot:noOptions>
                  {{ $t('general.noResult') }}
                </template>
                <template slot="tag" slot-scope="{ option, remove }">
                  <span
                    class="custom__tag badge badge-primary badge-pill"
                    style="font-size: 1em; margin-right: 5px; cursor: pointer"
                    v-html="option.name"
                    @click="remove(option)"
                  >
                  </span>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>

          <b-col sm="12" lg="4">
            <b-form-group
              id="group-work-orders"
              :label="$t('workOrders.workOrders')"
              label-class="no-bold"
              label-for="workOrderSelect"
            >
              <multiselect
                id="workOrderSelect"
                v-model="selectedWorkOrder"
                :options="workOrdersList"
                :show-labels="false"
                :searchable="true"
                :label="'name'"
                track-by="idPublic"
                :placeholder="$t('general.pickAValue')"
              >
                <template v-slot:noOptions>
                  {{ $t('general.noResult') }}
                </template>

                <template slot="singleLabel" slot-scope="{ option }">
                  <div class="flex-box">
                    <div>{{ option.name }}</div>
                    <div
                      class="flex-push"
                      style="
                        padding-left: 10px;
                        padding-right: 5px;
                        cursor: pointer;
                      "
                      @mousedown.prevent.stop="selectedWorkOrder = null"
                    >
                      <i class="fas fa-times text-secondary"></i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>

          <b-col sm="12" lg="4">
            <b-form-group
              id="group-items"
              :label="$t('items.items')"
              label-class="no-bold"
              label-for="itemSelect"
            >
              <multiselect
                id="itemSelect"
                v-model="selectedItem"
                :options="itemsList"
                :show-labels="false"
                :searchable="true"
                :label="'name'"
                track-by="idPublic"
                :placeholder="$t('general.pickAValue')"
              >
                <template v-slot:noOptions>
                  {{ $t('general.noResult') }}
                </template>

                <template slot="singleLabel" slot-scope="{ option }">
                  <div class="flex-box">
                    <div>{{ option.name }}</div>
                    <div
                      class="flex-push"
                      style="
                        padding-left: 10px;
                        padding-right: 5px;
                        cursor: pointer;
                      "
                      @mousedown.prevent.stop="selectedItem = null"
                    >
                      <i class="fas fa-times text-secondary"></i>
                    </div>
                  </div>
                </template>
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="12" lg="4">
            <b-form-group
              id="group-status"
              :label="$t('general.status')"
              label-class="no-bold"
              label-for="statusSelect"
            >
              <StatusMultiselect
                :list="getOrderStatus()"
                :defaultSelectedList="selectedStatus"
                @selection-change="(l) => statusSelectionChanged(l)"
              />
            </b-form-group>
          </b-col>

          <b-col sm="12" lg="4" class="flex-vertical-align-bottom">
            <div style="padding-bottom: 18px">
              <b-form-checkbox
                id="checkbox-show-closed"
                v-model="showClosed"
                name="checkbox-show-closed"
                @change="showClosedChanged"
                switch
              >
                <span class="no-bold">{{ $t('orders.showClosed') }}</span>
              </b-form-checkbox>
            </div>
          </b-col>
        </b-row>
      </template>
    </FiltersCard>

    <Grid v-if="filters != null" :filters="filters" :fields="fieldsComputed" />
  </Layout>
</template>

<style scoped>
.search-bar {
  max-width: 500px;
  max-height: 40px;
  background-color: white;
  border-radius: 5px;
}
</style>
